import PendoIcon from '../../icon/pendo-icon.vue.js';

var script = {
  name: 'PendoAppCell',
  components: {
    PendoIcon
  },
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  computed: {
    icon() {
      return {
        web: 'monitor',
        extension: 'puzzle-piece',
        ios: 'ios',
        android: 'android'
      }[this.row.app.platform];
    },
    name() {
      return this.row.app.displayName || this.row.app.name;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-app-cell.vue2.js.map
